<script setup lang="ts">
import InputText from '@/components/input-text.vue';
import { AssetType } from '@/features/assets/constants';
import InvoiceSkeletonPlaceholderText from '@/features/invoices/components/partials/InvoiceSkeletonPlaceholderText.vue'
import { format } from 'date-fns/format'

defineProps<{ invoiceNumber?: string, date?: Date, dateFormat: string, period?: [Date, Date], assetType?: AssetType }>()
const recsGenerated = defineModel<string|null>('recsGenerated')
</script>

<template>
  <div :class="$style.wrapper" class="d-grid">
    <span>Invoice Number</span>
    <span>
      <template v-if="invoiceNumber">{{ invoiceNumber }}</template>
      <InvoiceSkeletonPlaceholderText v-else />
    </span>

    <span>Invoice Date</span>
    <span>
      <template v-if="date">{{ format(date, dateFormat) }}</template>
      <InvoiceSkeletonPlaceholderText v-else />
    </span>

    <span v-if="assetType != AssetType.Wheeling">Invoice Period</span>
    <span v-if="assetType != AssetType.Wheeling">
      <template v-if="period">{{ format(period[0], dateFormat) }} - {{ format(period[1], dateFormat) }}</template>
      <InvoiceSkeletonPlaceholderText v-else />
    </span>

    <span>REC's Generated</span>
    <span><InputText v-model:value="recsGenerated" v-if="assetType == AssetType.Wheeling"/></span>
  </div>
</template>

<style module lang="scss">
.wrapper {
  grid-template-columns: 1fr 1fr;
}
</style>
